jQuery(function($){
	  'use strict';
	
	  const VISIBLE_TABS = 3;
	
	  $('.js-tab-title').click(function() {
		var tab = $(this).data('target');
		var section = $(this).closest('.js-module');
	
		section.find('.js-tab').addClass('is-hidden');
		$(tab).removeClass('is-hidden');
	
		section.find('.js-tab-title').removeClass('is-active');
		$(this).addClass('is-active');
		return false;
	  });
	
	  $('.js-tabs-previous').click(function() {
		var section = $(this).closest('.js-module');
		var tabTitles = section.find('.js-tab-title');
		var visibleTabTitles = tabTitles.not('.is-hidden');
		var lastEl = tabTitles.last();
		var lastVisibleEl = visibleTabTitles.last();
		var index = tabTitles.index(lastVisibleEl);
		var lastIndex = tabTitles.index(lastEl);
		var tabs = section.find('.js-tab');
		var recent = section.find('.js-tabs-recent');
		var firstHiddenIndex = index + 1;
	
		tabTitles.addClass('is-hidden');
		tabs.addClass('is-hidden');
		tabTitles.removeClass('is-active');
		$(this).removeClass('tabs__previous--division');
		recent.removeClass('tabs__recent--division');
	
		if (index < lastIndex) {
		  for (var i = firstHiddenIndex; i <= Math.min(lastIndex, index + VISIBLE_TABS); i++) { 
			tabTitles.eq(i).removeClass('is-hidden');
		  }      
		}
	
		tabTitles.eq(firstHiddenIndex).addClass('is-active');
		tabs.eq(firstHiddenIndex).removeClass('is-hidden');
	
		if (index + VISIBLE_TABS >= lastIndex){
		  $(this).addClass('is-hidden');
		} else {
		  $(this).addClass('tabs__previous--division');
		  recent.addClass('tabs__recent--division');
		}
	
		recent.removeClass('is-hidden');
	
		return false;
	  });
	
	  $('.js-tabs-recent').click(function() {
		var section = $(this).closest('.js-module');
		var tabTitles = section.find('.js-tab-title');
		var visibleTabTitles = tabTitles.not('.is-hidden');
		var firstVisibleEl = visibleTabTitles.first();
		var index = tabTitles.index(firstVisibleEl);
		var firstIndex = 0;
		var tabs = section.find('.js-tab');
		var previous = section.find('.js-tabs-previous');
		var firstHiddenIndex = index - VISIBLE_TABS;
	
		tabTitles.addClass('is-hidden');
		tabs.addClass('is-hidden');
		tabTitles.removeClass('is-active');
		$(this).removeClass('tabs__recent--division');
		previous.removeClass('tabs__previous--division');
		
		for (var i = firstHiddenIndex; i < index; i++) { 
		  tabTitles.eq(i).removeClass('is-hidden');
		}      
	
		tabTitles.eq(firstHiddenIndex).addClass('is-active');
		tabs.eq(firstHiddenIndex).removeClass('is-hidden');
	
		if (firstHiddenIndex <= firstIndex){
		  $(this).addClass('is-hidden');
		} else {
		  $(this).addClass('tabs__recent--division');
		  previous.addClass('tabs__previous--division');
		}
	
		previous.removeClass('is-hidden');
	
		return false;
	  });

	  // Results tabs

	  jQuery('.load-more-assets a').on("click", function(e) {
		e.preventDefault();
		jQuery(this).closest('.tabs__tab').addClass('view-all').find('.asset-text-wrapper').removeClass('is-hidden');
		jQuery(this).addClass('is-hidden');
	  });
	
	});